import { render, staticRenderFns } from "./list-table.vue?vue&type=template&id=588e9774&scoped=true"
import script from "./list-table.ts?vue&type=script&lang=ts&external"
export * from "./list-table.ts?vue&type=script&lang=ts&external"
import style0 from "./list-table.scss?vue&type=style&index=0&id=588e9774&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588e9774",
  null
  
)

export default component.exports